import { Modal } from '@carbon/react';

import type { LargeTableWarning } from '../types';
import { formatCount } from '../utils';

/**
 * Asked at Next when the server will build an Assets table above its warning
 * size only once the user agrees: Continue builds it, Cancel stays on Select
 * Source with nothing built. Rendered only while asking.
 *
 * @param {LargeTableWarning} props - The table's size and the two answers
 * @return {JSX.Element} The modal
 */
export function LargeTableModal({
  assetCount,
  onContinue,
  onCancel,
}: LargeTableWarning) {
  return (
    <Modal
      open
      size="sm"
      modalHeading="Build a large Assets table?"
      primaryButtonText="Continue"
      secondaryButtonText="Cancel"
      onRequestSubmit={onContinue}
      onRequestClose={onCancel}
      preventCloseOnClickOutside
    >
      <p>
        The Assets table will have {formatCount(assetCount)} assets. Building it
        may take a while. Do you want to continue?
      </p>
    </Modal>
  );
}
